// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Charge } from '../_models/charge.model';
import { Shipment } from '../_models/shipment.model';
// State
import { ChargeState } from '../_reducers/charge.reducers';

export const selectChargeState = createFeatureSelector<ChargeState>('charge');

export const selectChargeById = (chargeId: number) =>
  createSelector(
    selectChargeState,
    chargeState => chargeState.entities[chargeId]
  );

export const selectChargesByUid = (uid: number) =>
  createSelector(selectChargeState, chargeState =>
    Object.values(chargeState.entities).filter(charge => charge.user === uid)
  );

export const selectChargesForShipment = (sh: Shipment) =>
  createSelector(selectChargeState, chargeState => {
    //Filter charges by dates created relative to shipment date approved or now() if pending
    //
    let charges: Array<Charge> = Object.values(chargeState.entities)
      .filter(charge => charge.user === sh.user)
      .filter(charge => {
        const cdc: Date = new Date(charge.date_created);
        let shdc: Date = null;
        if (sh.date_approved) {
          shdc = new Date(sh.date_approved);
        } else {
          shdc = new Date(Date.now());
        }

        return shdc.getTime() >= cdc.getTime();
      });

    if (!charges.length) {
      return null;
    }

    const mrd = new Date(
      Math.max.apply(
        null,
        charges.map(ch => {
          return new Date(ch.date_created);
        })
      )
    );

    charges = charges.filter(ch => {
      const d = new Date(ch.date_created);
      return d.getTime() == mrd.getTime();
    });

    //Filter charges based on shipment weight
    let mw = -1.0;
    charges.forEach(ch => {
      if (parseFloat('' + sh.weight) > parseFloat('' + ch.weight_start)) {
        if (mw < parseFloat('' + ch.weight_start)) {
          mw = parseFloat('' + ch.weight_start);
        }
      }
    });
    charges = charges.filter(ch => parseFloat('' + ch.weight_start) == mw);

    return charges[0];
  });
